import React from 'react'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom'
import AccountOverview from '../Common/AccountOverview'

const BinaryRoutes = ({match: {path}}) => (
  <Switch>
    <Redirect from={`${path}/transactions`} to="/transactions/:accountId/deposit"/>
    <Route exact path={`${path}`} component={AccountOverview} />
  </Switch>
)

export default withRouter(BinaryRoutes)
